export default {
    timeTableSetting: 'Time Table Setting',
    workday: 'Workday',
    specialWorkday: 'Special Workday',
    groupHoliday: 'Group Holiday'
}
